import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyLegLoadTotalExtensionsPage } from './daily-leg-load-total-extensions';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    DailyLegLoadTotalExtensionsPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(DailyLegLoadTotalExtensionsPage),
  ],
})
export class DailyLegLoadTotalExtensionsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-total-extensions/daily-leg-load-total-extensions.module.ts